import { render, staticRenderFns } from "./BoHeader.vue?vue&type=template&id=2dd696e0&"
import script from "./BoHeader.vue?vue&type=script&lang=js&"
export * from "./BoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports